// extracted by mini-css-extract-plugin
export default {"form":"Login_form__rXLq9","email":"Login_email__XqRDO","forFlex":"Login_forFlex__7sj2u","title":"Login_title__J6Zv-","password":"Login_password__KtLV6"};